import type { FC } from 'react';
import type { StrategyFormData } from './types';
import styles from './Strategies.module.css';

interface StrategyModalProps {
  isEdit: boolean;
  formData: StrategyFormData;
  onFormChange: (data: StrategyFormData) => void;
  onSave: () => void;
  onClose: () => void;
}

export const StrategyModal: FC<StrategyModalProps> = ({ isEdit, formData, onFormChange, onSave, onClose }) => {
  return (
    <div
      className={styles.modalOverlay}
      role="dialog"
      aria-modal="true"
      aria-label={isEdit ? 'Edit strategy' : 'Create new strategy'}
    >
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>{isEdit ? 'Edit Strategy' : 'Create New Strategy'}</h2>
          <button className={styles.closeButton} onClick={onClose} aria-label="Close dialog">
            ×
          </button>
        </div>

        <div className={styles.formGroup}>
          <label className={styles.label} htmlFor="strategy-name">
            Strategy Name
          </label>
          <input
            className={styles.input}
            id="strategy-name"
            type="text"
            value={formData.name}
            onChange={(e) => onFormChange({ ...formData, name: e.target.value })}
            placeholder="e.g., SQL Injection, BOLA Detection"
          />
        </div>

        <div className={styles.formGroup}>
          <label className={styles.label} htmlFor="strategy-type">
            Type
          </label>
          <select
            className={styles.select}
            id="strategy-type"
            value={formData.type}
            onChange={(e) => onFormChange({ ...formData, type: e.target.value as StrategyFormData['type'] })}
          >
            <option value="active">Active Check</option>
            <option value="passive">Passive Check</option>
          </select>
        </div>

        <div className={styles.formGroup}>
          <label className={styles.label} htmlFor="strategy-content">
            Strategy Content (Jinja2 Template)
          </label>
          <textarea
            className={styles.textarea}
            id="strategy-content"
            value={formData.content}
            onChange={(e) => onFormChange({ ...formData, content: e.target.value })}
            placeholder="Enter your strategy template..."
          />
        </div>

        <div className={styles.buttonGroup}>
          <button className={styles.button} onClick={onClose}>
            Cancel
          </button>
          <button className={styles.button} data-variant="primary" onClick={onSave}>
            {isEdit ? 'Save Changes' : 'Create Strategy'}
          </button>
        </div>
      </div>
    </div>
  );
};
